import { Outlet, useParams } from 'react-router-dom'

import { isEmpty } from 'lodash'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import CollectionsBootstrap from 'modules/performance_goals/lib/CollectionsBootstrap'

const RootPage = () => {
  const params = useParams()

  useEffect(() => {
    // Ensure we only track the first time the user visits the goals module
    if (isEmpty(params)) track(trackingEvents.performanceGoals.goToGoal)
  }, [])

  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
